import { Box, IconButton, Stack, Typography } from "@mui/material";
import { useContext, useEffect, useState } from "react";
import { isMobile } from "react-device-detect";
import { useTranslation } from "react-i18next";
import CustomizeIcon from "../../../Assets/Icons/CustomizeIcon.svg";
import { ColorScheme } from "../../../Themes/ColorScheme";
import { ApiContext } from "../../ApiContext";
import { AlertBar } from "../../Common/AlertBar";
import { UserContext } from "../../UserContext";
import { FormCancel } from "./Buttons/FormCancel";
import { FormSave } from "./Buttons/FormSave";
import { LocationImages } from "./LocationImages";

export const PhotoDetail = () => {

	const [editMode, setEditMode] = useState(false);

	const [images, setImages] = useState([]);

	const [loading, setLoading] = useState(false);

	const { ApiCall } = useContext(ApiContext);

	const { t } = useTranslation();
	const { selectedLocation } = useContext(UserContext);

	useEffect(() => {
		setEditMode(false);
	}, [selectedLocation]);

	const fetchLocationImages = () => {
		setLoading(true);
		ApiCall(
			"GET",
			`location/images/${selectedLocation.id}`,
			null
		)
			.then((images) => {
				setImages(images);
				setLoading(false);
			})
			.catch((error) => {
				console.log(error);
				setLoading(false);
				console.log(loading);
			});
	};

	useEffect(() => {
		if (
			Object.prototype.hasOwnProperty.call(
				selectedLocation,
				"id"
			) &&
			selectedLocation !== null &&
			selectedLocation !== undefined
		)
			fetchLocationImages();
	}, [selectedLocation, location]);

	return (
		<Stack
			direction="row"
			justifyContent="space-between"
			sx={{
				padding: "15px",
				border: editMode ? "1px dashed " + ColorScheme.secondary : "0px",
				borderRadius: "4px"
			}}
		>
			<div
				style={{
					flexDirection: "row",
					display: "flex",
					flex: 1,
					justifyContent: "flex-start"
				}}
			>
				<Stack spacing={3} sx={{ width: "100%" }}>
					{editMode && (
						<div
							style={{
								display: "flex",
								flexDirection: "row",
								justifyContent: "space-between",
								width: "100%"
							}}
						>
							<div />
							<AlertBar
								textContent={t("images.how_to_add_new_image")}
								type="info"
								showAlert
							/>
						</div>
					)}

					<div
						style={{
							flexDirection: "row",
							display: "flex",
							flex: 1,
							justifyContent: "space-between",
							alignItems: "center"
						}}
					>
						<div style={{ minWidth: isMobile ? "100px" : "150px" }}>
							<Typography variant="form_text_label">
								{t("location.form_location_logo_label")}:
							</Typography>
						</div>
						<Stack
							justifyContent={"flex-end"}
							spacing={1}
							width={"100%"}
						>
							<LocationImages
								images={images}
								editMode={editMode}
								isBanner={false}
								refreshList={fetchLocationImages}
							/>
						</Stack>
					</div>

					<div
						style={{
							flexDirection: "row",
							display: "flex",
							flex: 1,
							justifyContent: "space-between",
							alignItems: "center"
						}}
					>
						<div style={{ minWidth: isMobile ? "100px" : "150px" }}>
							<Typography variant="form_text_label">
								{t("location.form_location_cover_image_label")}:
							</Typography>
						</div>
						<Stack spacing={1} width={"100%"}>
							<LocationImages
								editMode={editMode}
								isBanner={true}
								images={images}
								refreshList={fetchLocationImages}
							/>
						</Stack>
					</div>
					{editMode && (
						<Box
							sx={{
								width: "100%",
								display: "flex",
								justifyContent: "flex-end"
							}}
						>
							<FormCancel cancelAction={() => setEditMode(false)} />
							<FormSave handleSave={() => setEditMode(false)} />
						</Box>
					)}
				</Stack>
			</div>
			{!editMode && (
				<IconButton
					onClick={() => setEditMode(!editMode)}
					sx={{ marginLeft: "15px" }}
				>
					<img src={CustomizeIcon} />
				</IconButton>
			)}
		</Stack>
	);
};
